import type { ReactNode } from "react"

import { CRTOverlay } from "@/components/crt-overlay"

interface BroadcastShowProps {
  children: ReactNode
}

/**
 * Full-page broadcast wrapper. Everything below the hero lives inside this.
 * Provides consistent dark background + CRT overlay for the entire show.
 */
export function BroadcastShow({ children }: BroadcastShowProps) {
  return (
    <div
      className="relative"
      style={{
        width: "100vw",
        marginLeft: "calc(-50vw + 50%)",
        background: "oklch(0.09 0.01 55)",
      }}
    >
      <div
        className="pointer-events-none absolute inset-0"
        style={{ zIndex: 2, willChange: "transform" }}
      >
        <CRTOverlay />
      </div>
      <div
        className="relative space-y-16 py-16 md:space-y-24 md:py-24"
        style={{ zIndex: 3 }}
      >
        {children}
      </div>
    </div>
  )
}
